<!-- 知识讲堂详情 -->
<template>
  <div id="target">
    <div class="essay">
      <div class="essayTitle">{{ list.title }}</div>
      <div
        class="rikind"
        style="text-align: right;"
      >
        {{ list.CreateTime }}
      </div>
      <!-- <div class="rikind">{{ list.AKName }}</div> -->
      <!-- <div v-if="list.Thematic" class="essayImg">
        <img :src="list.Thematic" alt="" style="width:90%;margin:15px 5%" />
      </div> -->
      <!-- <div class="essayContent" v-html="dataForm.content"></div> -->
      <div
        class="essayContent"
        v-html="list.content"
        @click="imageEnlargement"
      ></div>
      <div
        class="video"
        v-if="list.Video"
      >
        <video
          style="width: 100%"
          :src="list.Video"
          controls="controls"
        >
          您的浏览器不支持 video 标签。
        </video>
      </div>
      <div v-if="list.img">
        <div
          class="pic"
          v-for="(item,index) in list.img.split(',')"
          :key="index"
        >
          <img
            :src="item"
            alt=""
          >
        </div>
      </div>
      <div v-else>
        <div class="pic">
          <img
            src="https://new-zhsq.oss-cn-beijing.aliyuncs.com/goodsImg/cdb4.png"
            alt=""
          >
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { ImagePreview } from 'vant'
import { WeGetGoodNews, getDetials } from '@/api/Hyapi'
import { setOpenId, getOpenId } from '@/utils/auth'
import { Dialog } from 'vant'
export default {
  components: {
    [Dialog.Component.name]: Dialog.Component,
  },
  data () {
    return {
      list: {}, //活动详情
      gnId: 0, //活动aid
      ActivityFrom: {}, //活动申请提交参数
    }
  },
  created () {
    window.scroll(0, 0)
    // 获取并保存openid
    // if (this.$route.query["openid"]) {
    //   setOpenId(this.$route.query["openid"]);
    // }
  },
  methods: {
    // 富文本图片内容 点击放大
    imageEnlargement (e) {
      if (e.target.nodeName === 'IMG') {
        ImagePreview({
          images: [e.target.src], // 传递的是图片集数组
          startPosition: 0, // 图片索引位置
          closeable: true, // 是否显示关了按钮
          showIndicators: true, // 是否显示轮播指示器
          loop: false, // 不设置为false,首图和尾部图不能正常加载
        })
      }
    },
    // 获取活动详情
    getRealInfo () {
      this.gnId = this.$route.params.Id
      getDetials(this.gnId).then((res) => {
        this.list = res.data.data
      })
    },
  },
  mounted () {
    this.getRealInfo()
  },
}
</script>
<style>
.button {
  width: 95%;
  margin: 15px 2.5%;
}
.pic {
  width: 100%;
  /* height: 200px; */
  margin: 0 auto;
}
.pic img {
  width: 100%;
}
</style>
